import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Icon } from '@iconify/react';

function NetworkPart1(props) {

    const {
        certInNetworkClientName, setCertInNetworkClientName, certInNetworkConsultantName, setCertInNetworkConsultantName,
        certInNetworkDate, setCertInNetworkDate, clientLogoSelected, clientLogoFetched, setClientLogoSelected, setClientLogoFetched,
        certInNetworkCustomerName, setCertInNetworkCustomerName, isImageSelected, setIsImageSelected,
        certInNetworkLogo, setCertInNetworkLogo,
        certInNetworkApplicationIP, setCertInNetworkApplicationIP,
        certInNetworkStartDate, setCertInNetworkStartDate,
        certInNetworkEndDate, setCertInNetworkEndDate,
        certInNetworkTestingype, setCertInNetworkTestingType,
        certInNetworkAppDescription, setCertInNetworkAppDescription,
        certInNetworkAppEnvironment, setCertInNetworkAppEnvironment,
        criticalityNetwork, setCriticalityNetwork,
        imageUrlNetwork, setImageUrlNetwork,
        inchargeNameNetwork, setInchargeNameNetwork,
        inchargeEmailNetwork, setInchargeEmailNetwork,
        inchargeDesignationNetwork, setInchargeDesignationNetwork,
        certInNetworkDownloading, setCertInNetworkownloading,
        certInNetworkVulnerabilities, setCertInNetworkVulnerabilities,
        certInNetworkCurrentPage, setCertInNetworkCurrentPage, handleCertInNetworkPhase1Download,
        handleCertInNetworkDataCancel, handleCertInNetworkCancel, capitalizeFirstLetter, handleNextPage, handleCertInNetworkDownload
    } = props

    const [clientNetworkNames, setClientNetworkNames] = useState(certInNetworkClientName.length > 0 ? certInNetworkClientName : [""]);
    const [consultantNetworkNames, setConsultantNetworkNames] = useState(certInNetworkConsultantName.length > 0 ? certInNetworkConsultantName : [""]);

    const addNetworkClientName = () => {
        setClientNetworkNames([...clientNetworkNames, ""]);
    };

    const handleClientImageChange = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (file && allowedTypes.includes(file.type)) {
            setCertInNetworkLogo(file);
            const url = URL.createObjectURL(file);
            console.log("Image URL: ", url);
            setImageUrlNetwork(url);
            setIsImageSelected(true);
            // setClientImageError('');
        } else {
            // setClientImageError('Please select a valid image file (jpg, jpeg, png).');
            setCertInNetworkLogo(null);
            setImageUrlNetwork('');
            setIsImageSelected(false);
        }
    };

    const removeNetworkClientName = (index) => {
        const newClientNames = [...clientNetworkNames];
        newClientNames.splice(index, 1);
        setClientNetworkNames(newClientNames);
        setCertInNetworkClientName(newClientNames);
    };

    const handleNetworkClientNameChange = (index, value) => {
        const newClientNames = [...clientNetworkNames];
        newClientNames[index] = capitalizeFirstLetter(value);
        setClientNetworkNames(newClientNames);
        setCertInNetworkClientName(newClientNames);
    };

    const addNetworkConsultantName = () => {
        setConsultantNetworkNames([...consultantNetworkNames, ""]);
    };

    const removeNetworkConsultantName = (index) => {
        const newConsultantNames = [...consultantNetworkNames];
        newConsultantNames.splice(index, 1);
        setConsultantNetworkNames(newConsultantNames);
        setCertInNetworkConsultantName(newConsultantNames);
    };

    const handleNetworkConsultantNameChange = (index, value) => {
        const newConsultantNames = [...consultantNetworkNames];
        newConsultantNames[index] = capitalizeFirstLetter(value);
        setConsultantNetworkNames(newConsultantNames);
        setCertInNetworkConsultantName(newConsultantNames);
    };



    return (
        <div className='report_part2'>
            <div className='report_part2_content'>
                <div className='report_part1_heading'>
                    <h1>Part 1 Network Cert-In Format</h1>
                </div>
                <div className='report_part1_input'>
                    <div className='report_part1_leftside'>
                        <div className='report_input'>
                            <label>Customer Name</label>
                            <input type='text' placeholder='Customer name' value={certInNetworkCustomerName} onChange={(e) => {
                                setCertInNetworkCustomerName(capitalizeFirstLetter(e.target.value))
                            }} />
                        </div>

                        <div className='report_input'>
                            <label>Test Start Date</label>
                            <input type='date' value={certInNetworkStartDate} onChange={(e) => {
                                setCertInNetworkStartDate(e.target.value)
                            }} />
                        </div>
                        <div className='report_input'>
                            <label>Name and Company</label>
                            {clientNetworkNames.map((name, index) => (
                                <div className='practice_data' key={index}>
                                    <div className="input_box">
                                        <input
                                            type='text'
                                            placeholder='Name (Company)'
                                            value={name}
                                            onChange={(e) => {
                                                handleNetworkClientNameChange(index, e.target.value);

                                            }}
                                        />
                                        {clientNetworkNames.length > 0 && (
                                            <button onClick={() => removeNetworkClientName(index)}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                    </div>
                                    <button className='diff_button' onClick={addNetworkClientName}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faPlus} /> </span>Add</button>

                                </div>
                            ))}
                        </div>
                        <div className='report_input'>
                            <label>Consultant Name</label>
                            {consultantNetworkNames.map((name, index) => (
                                <div className='practice_data' key={index}>
                                    <div className="input_box">
                                        <input type='text'
                                            placeholder='Consultant Name'
                                            value={name}
                                            onChange={(e) => {
                                                handleNetworkConsultantNameChange(index, e.target.value);

                                            }}
                                        />
                                        {index !== consultantNetworkNames.length - 0 && (
                                            <button onClick={() => {
                                                removeNetworkConsultantName(index)
                                            }}><FontAwesomeIcon icon={faTimes} /></button>
                                        )}
                                    </div>
                                    <button className='diff_button' onClick={addNetworkConsultantName}><span style={{ marginRight: "5px" }}><FontAwesomeIcon icon={faPlus} /> </span>Add</button>

                                </div>
                            ))}
                        </div>
                        <div className='report_input'>
                            <label>Testing Type</label>
                            <select value={certInNetworkTestingype} onChange={(e) => {
                                setCertInNetworkTestingType(e.target.value)
                            }}>
                                <option>Select</option>
                                <option>Black box testing methodology (Unauthenticated Testing)</option>
                                <option>Combination of Black Box testing methodology (Unauthenticated testing) and Grey Box testing methodology (Authenticated Testing)</option>
                            </select>
                        </div>

                        <div className='report_input'>
                            <label>Criticality of Asset</label>
                            <select value={criticalityNetwork} onChange={(e) => {
                                setCriticalityNetwork(e.target.value)
                            }}>
                                <option>Select</option>
                                <option>High</option>
                                <option>Medium</option>
                                <option>Low</option>
                            </select>
                        </div>


                    </div>
                    <div className='report_part1_rightside'>
                        <div className='report_input'>
                            <label>Report Date</label>
                            <input type='date' value={certInNetworkDate} onChange={(e) => {
                                setCertInNetworkDate(e.target.value)
                            }} />
                        </div>

                        <div className='report_input'>
                            <label>Client Logo </label>

                            {!clientLogoSelected && !clientLogoFetched && !imageUrlNetwork && (
                                <input type='file' onChange={handleClientImageChange} />
                            )}
                            {imageUrlNetwork && (
                                <div>
                                    {console.log(imageUrlNetwork)}
                                    <img src={imageUrlNetwork} alt="Uploaded logo" style={{ width: '100px', height: '30px' }} />
                                </div>
                            )}
                        </div>

                        <div className='report_input'>
                            <label>Test End Date</label>
                            <input type='date' value={certInNetworkEndDate} onChange={(e) => {
                                setCertInNetworkEndDate(e.target.value)
                            }} />
                        </div>

                        <div className='report_input_description'>
                            <label>Application IP</label>
                            <textarea placeholder='Application IP' style={{padding:"7px"}} value={certInNetworkApplicationIP} onChange={(e) => {
                                setCertInNetworkApplicationIP(e.target.value)
                            }} />
                        </div>

                        <div className='report_input_description'>
                            <label>Application Description</label>
                            <textarea placeholder='Application Description' style={{padding:"7px"}} value={certInNetworkAppDescription} onChange={(e) => {
                                setCertInNetworkAppDescription(e.target.value)
                            }} />
                        </div>



                    </div>
                </div>
                <div className='report_part1_button'>
                    <button disabled={certInNetworkCurrentPage === 1}><Icon icon="stash:arrow-left-light"  className="prev_icon" /></button>

                    {/*<button style={{ fontSize: "13px", marginRight: "20px" }} disabled={certInNetworkCurrentPage === 1}>Prev</button>*/}
                    <button className='part1_cancel_button' onClick={handleCertInNetworkCancel}>Cancel</button>
                    <button className='part1_upload_button' onClick={handleCertInNetworkDownload}>Download</button>
                    {/*<button style={{ fontSize: "13px", marginLeft: "20px" }} onClick={handleNextPage}>Next</button>*/}
                    <Icon icon="stash:arrow-right-light" onClick={handleNextPage} className="next_icon" />

                </div>
                <div>
                </div>
            </div>
        </div>
    )
}

export default NetworkPart1



/*<div className='multiple_data' key={index}>
                                    <input
                                        type='text'
                                        placeholder='Name (Company)'
                                        value={name}
                                        onChange={(e) => {
                                            handleNetworkClientNameChange(index, e.target.value);

                                        }}
                                    />
                                    {clientNetworkNames.length > 0 && (
                                        <button className='remove_more_button' onClick={() => removeNetworkClientName(index)}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                    )}
                                </div>*/